function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1968(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.88,
    height: 8.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4833333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 4.45,
    fontFamily: "Arial"
  }, "\n        Forest\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.9,
    width: 22.88,
    height: 12.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.61875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 15.375,
    fontFamily: "Arial"
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.85,
    width: 22.88,
    height: 13.94,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9914285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 28.82,
    fontFamily: "Arial"
  }, "\n        Cameron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35.79,
    width: 22.88,
    height: 17.92,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.986666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 44.75,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 53.71,
    width: 22.88,
    height: 26.12,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 66.77,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 79.83,
    width: 22.88,
    height: 26.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2685714285714282
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 93.31,
    fontFamily: "Arial"
  }, "\n        Montour\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 106.79,
    width: 22.88,
    height: 28.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.813333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 121.09,
    fontFamily: "Arial"
  }, "\n        Potter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 135.39,
    width: 22.88,
    height: 31.01,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2685714285714282
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 150.89499999999998,
    fontFamily: "Arial"
  }, "\n        Juniata\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 166.4,
    width: 22.88,
    height: 36.65,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2685714285714282
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 184.725,
    fontFamily: "Arial"
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 203.05,
    width: 22.88,
    height: 41.57,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.576
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 223.835,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 244.62,
    width: 22.88,
    height: 42.72,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.813333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 265.98,
    fontFamily: "Arial"
  }, "\n        Snyder\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 287.33,
    width: 22.88,
    height: 48.94,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.576
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 311.79999999999995,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 336.27,
    width: 22.88,
    height: 53.19,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.576
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 362.865,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 389.46,
    width: 22.88,
    height: 60.4,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.288
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 419.65999999999997,
    fontFamily: "Arial"
  }, "\n        Huntingdon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 449.86,
    width: 22.88,
    height: 60.94,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2685714285714282
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 480.33000000000004,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 510.8,
    width: 22.88,
    height: 62.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.576
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 542.07,
    fontFamily: "Arial"
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 573.33,
    width: 22.88,
    height: 63.3,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 604.98,
    fontFamily: "Arial"
  }, "\n        Susquehanna\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 636.64,
    width: 22.88,
    height: 63.36,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.626666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.44,
    y: 668.3199999999999,
    fontFamily: "Arial"
  }, "\n        Elk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.88,
    y: 0,
    width: 41.42,
    height: 35.88,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.59,
    y: 17.94,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.3,
    y: 0,
    width: 41.48,
    height: 35.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.125714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.03999999999999,
    y: 17.94,
    fontFamily: "Arial"
  }, "\n        Clarion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.78,
    y: 0,
    width: 42.27,
    height: 35.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.125714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.915,
    y: 17.94,
    fontFamily: "Arial"
  }, "\n        Mifflin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.05,
    y: 0,
    width: 45.93,
    height: 35.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.01500000000001,
    y: 17.94,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.98,
    y: 0,
    width: 47.51,
    height: 35.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.125714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.73499999999999,
    y: 17.94,
    fontFamily: "Arial"
  }, "\n        Bedford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.48,
    y: 0,
    width: 50.64,
    height: 35.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.8,
    y: 17.94,
    fontFamily: "Arial"
  }, "\n        McKean\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.12,
    y: 0,
    width: 51.04,
    height: 35.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.64,
    y: 17.94,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.17,
    y: 0,
    width: 52.77,
    height: 35.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.986666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.555,
    y: 17.94,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 395.93,
    y: 0,
    width: 54.38,
    height: 35.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.176
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 423.12,
    y: 17.94,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450.31,
    y: 0,
    width: 60.56,
    height: 35.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 480.59000000000003,
    y: 17.94,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.88,
    y: 0,
    width: 62.06,
    height: 35.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.91,
    y: 17.94,
    fontFamily: "Arial"
  }, "\n        Carbon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 572.94,
    y: 0,
    width: 63.13,
    height: 35.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.125714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 604.5050000000001,
    y: 17.94,
    fontFamily: "Arial"
  }, "\n        Venango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.07,
    y: 0,
    width: 63.93,
    height: 35.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.0350000000001,
    y: 17.94,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.88,
    y: 35.88,
    width: 58.15,
    height: 50.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.955,
    y: 60.93000000000001,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.88,
    y: 85.98,
    width: 58.15,
    height: 50.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.438333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.955,
    y: 111.295,
    fontFamily: "Arial"
  }, "\n        Centre\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.88,
    y: 136.61,
    width: 58.15,
    height: 51.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.176
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.955,
    y: 162.49,
    fontFamily: "Arial"
  }, "\n        Clearfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.88,
    y: 188.37,
    width: 58.15,
    height: 51.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.402857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.955,
    y: 214.28,
    fontFamily: "Arial"
  }, "\n        Indiana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.88,
    y: 240.19,
    width: 58.15,
    height: 53.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.985555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.955,
    y: 267.125,
    fontFamily: "Arial"
  }, "\n        Armstrong\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.88,
    y: 294.07,
    width: 58.15,
    height: 54.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.86
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.955,
    y: 321.51,
    fontFamily: "Arial"
  }, "\n        Somerset\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.88,
    y: 348.95,
    width: 58.15,
    height: 60.39,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.307142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.955,
    y: 379.145,
    fontFamily: "Arial"
  }, "\n        Lebanon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.88,
    y: 409.34,
    width: 58.15,
    height: 62.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.26875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.955,
    y: 440.575,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.88,
    y: 471.81,
    width: 58.15,
    height: 74.37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.1535714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.955,
    y: 508.995,
    fontFamily: "Arial"
  }, "\n        Northumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.88,
    y: 546.17,
    width: 58.15,
    height: 76.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.26875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.955,
    y: 584.42,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.88,
    y: 622.68,
    width: 58.15,
    height: 77.32,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.26875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.955,
    y: 661.3399999999999,
    fontFamily: "Arial"
  }, "\n        Lycoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.02,
    y: 35.88,
    width: 57.27,
    height: 81.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.655,
    y: 76.69,
    fontFamily: "Arial"
  }, "\n        Butler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.29,
    y: 35.88,
    width: 61.07,
    height: 81.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.214
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 168.825,
    y: 76.69,
    fontFamily: "Arial"
  }, "\n        Blair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.36,
    y: 35.88,
    width: 62.09,
    height: 81.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.348333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.40500000000003,
    y: 76.69,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.44,
    y: 35.88,
    width: 67.61,
    height: 81.62,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.761
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.245,
    y: 76.69,
    fontFamily: "Arial"
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.05,
    y: 35.88,
    width: 75.17,
    height: 81.62,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.73857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.635,
    y: 76.69,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.22,
    y: 35.88,
    width: 96.91,
    height: 81.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.162
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.675,
    y: 76.69,
    fontFamily: "Arial"
  }, "\n        Schuylkill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.13,
    y: 35.88,
    width: 98.79,
    height: 81.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.420000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.525,
    y: 76.69,
    fontFamily: "Arial"
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.92,
    y: 35.88,
    width: 100.08,
    height: 81.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.9599999999999,
    y: 76.69,
    fontFamily: "Arial"
  }, "\n        Cambria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.02,
    y: 117.5,
    width: 94.9,
    height: 88.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.707142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.47,
    y: 161.975,
    fontFamily: "Arial"
  }, "\n        Dauphin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.02,
    y: 206.45,
    width: 94.9,
    height: 89.21,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.868333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.47,
    y: 251.05499999999998,
    fontFamily: "Arial"
  }, "\n        Beaver\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.02,
    y: 295.66,
    width: 94.9,
    height: 92.41,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.241
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.47,
    y: 341.865,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.02,
    y: 388.06,
    width: 94.9,
    height: 101.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.47,
    y: 438.83,
    fontFamily: "Arial"
  }, "\n        York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.02,
    y: 489.61,
    width: 94.9,
    height: 103.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.816666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.47,
    y: 541.49,
    fontFamily: "Arial"
  }, "\n        Lehigh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.02,
    y: 593.37,
    width: 94.9,
    height: 106.63,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.557142857142859
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.47,
    y: 646.685,
    fontFamily: "Arial"
  }, "\n        Chester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.92,
    y: 117.5,
    width: 91.06,
    height: 113.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.45,
    y: 174.085,
    fontFamily: "Arial"
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.98,
    y: 117.5,
    width: 98.77,
    height: 113.17,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.974444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 316.365,
    y: 174.085,
    fontFamily: "Arial"
  }, "\n        Lancaster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.75,
    y: 117.5,
    width: 99.33,
    height: 113.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.866
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 415.415,
    y: 174.085,
    fontFamily: "Arial"
  }, "\n        Berks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 465.08,
    y: 117.5,
    width: 104.32,
    height: 113.17,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.431999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 517.24,
    y: 174.085,
    fontFamily: "Arial"
  }, "\n        Lackawanna\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.4,
    y: 117.5,
    width: 130.6,
    height: 113.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.634
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 634.6999999999999,
    y: 174.085,
    fontFamily: "Arial"
  }, "\n        Bucks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.92,
    y: 230.67,
    width: 121.59,
    height: 121.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.71499999999997,
    y: 291.52,
    fontFamily: "Arial"
  }, "\n        Luzerne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.92,
    y: 352.37,
    width: 121.59,
    height: 126.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.1325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.71499999999997,
    y: 415.535,
    fontFamily: "Arial"
  }, "\n        Westmoreland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.92,
    y: 478.7,
    width: 121.59,
    height: 221.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.159
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.71499999999997,
    y: 589.35,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.51,
    y: 230.67,
    width: 109.4,
    height: 251.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 352.21,
    y: 356.34499999999997,
    fontFamily: "Arial"
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.91,
    y: 230.67,
    width: 293.09,
    height: 251.35,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.927777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 553.455,
    y: 356.34499999999997,
    fontFamily: "Arial"
  }, "\n        Allegheny\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.51,
    y: 482.02,
    width: 402.49,
    height: 217.98,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.165
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 498.755,
    y: 591.01,
    fontFamily: "Arial"
  }, "\n        Philadelphia\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1968);
export default __webpack_public_path__ + "static/media/1968.ea18d4fdbb37db2f99086fb64174bcb8.svg";
export { ForwardRef as ReactComponent };